
export function checkShowLicense(map) {
  const title = map ? map.name : '';
  const showLicenseTitles = ['1:5M Geological Map', '晚三叠世古地形图']
  if (showLicenseTitles.includes(title)) {
    return true;
  } else {
    return false;
  }
}